<template>
    <div class="king-trial t-a-c">
        <img :src="info.titlePic" class="d-i-b title-pic" alt="">
        <div class="kings m-0-a p-r o-h" :style="{background:'url('+info.kings_bg+') center center no-repeat;background-size: cover;'}">
            <a class="gift-btn d-b p-a" href="javascript:;" @click="showPopup =! showPopup">
                <img :src="info.gift_btn" alt="">
            </a>
        </div>
        <transition name="fade">
            <alert :info="popInfo" v-if="showPopup" @closePop="closePop"></alert>
        </transition>
    </div>
</template>

<style lang="less">
    .king-trial {
        margin-bottom: 1.733333rem;
        .title-pic {
            width: 6.666667rem;
            height: .826667rem;
            margin-bottom: .346667rem;
        }
        .kings {
            width: 9.733333rem;
            height: 4.346667rem;
            .gift-btn {
                width: 2.533333rem;
                height: 1.946667rem;
                top: 60%;
                right: -.266667rem;
                margin-top: -1.26rem;
            }
        }
    }
    
</style>
<script>
    import alert from '@components/common/alert/index'
    export default {
        components: {
            alert
        },
        props: ['info'],
        data() {
            return {
                showPopup: false
            }
        },
        computed: {
            popInfo() {
                return {
                    btn_close: this.info.btn_close,
                    content: this.info.pop_chest
                }
            }
        },
        methods: {
            closePop() {
                this.showPopup = !this.showPopup;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/smsgz/components/index/king-trial.vue